import { useTranslation } from 'react-i18next';
import { DropShiftHeaderMessageType } from '../../DropShiftModalContent/DropShiftModalContentTypes';
export var useDropShiftModalTitle = function (type) {
    var t = useTranslation().t;
    if (type === DropShiftHeaderMessageType.countdown) {
        return t('shift_management_features_DropShiftModal_standardTitle');
    }
    if (type === DropShiftHeaderMessageType.dropPenalty) {
        return t('shift_management_features_DropShiftModal_penaltyTitle');
    }
    return t('shift_management_features_DropShiftModal_undroppableTitle');
};
